import { amexAdapter } from "@/services/transactionsImport/adapters/amexAdapter";
import { wellsFargoAdapter } from "@/services/transactionsImport/adapters/wellsFargoAdapter";
import { citiAdapter } from "@/services/transactionsImport/adapters/citiAdapter";
import { chaseAdapter } from "@/services/transactionsImport/adapters/chaseAdapter";
import { lendClubAdapter } from "@/services/transactionsImport/adapters/lendingClub";

const REGISTERED_ADAPTERS = [
  amexAdapter,
  wellsFargoAdapter,
  citiAdapter,
  chaseAdapter,
  lendClubAdapter,
];

function normalizeInstitutionName(name) {
  return String(name || "")
    .trim()
    .toLowerCase();
}

(function validateNoDuplicateAliases() {
  const seenAliases = new Map();

  REGISTERED_ADAPTERS.forEach((adapter) => {
    (adapter.institutionAliases || []).forEach((alias) => {
      const normalized = normalizeInstitutionName(alias);
      if (seenAliases.has(normalized)) {
        throw new Error(
          `Duplicate institution alias "${normalized}" found in adapters "${seenAliases.get(
            normalized
          )}" and "${adapter.name}".`
        );
      }
      seenAliases.set(normalized, adapter.name);
    });
  });
})();

export function getAdapterForInstitution(institutionName) {
  const normalizedInstitutionName = normalizeInstitutionName(institutionName);
  if (!normalizedInstitutionName) {
    return null;
  }

  return (
    REGISTERED_ADAPTERS.find((adapter) => {
      if (typeof adapter.canHandleInstitutionName === "function") {
        return adapter.canHandleInstitutionName(normalizedInstitutionName);
      }

      return Array.isArray(adapter.institutionAliases)
        ? adapter.institutionAliases.includes(normalizedInstitutionName)
        : false;
    }) || null
  );
}

export function getSupportedInstitutionAliases() {
  return REGISTERED_ADAPTERS.flatMap(
    (adapter) => adapter.institutionAliases || []
  );
}
